module.exports = __webpack_public_path__ + "img/revision-policy.40eb20af.svg";